import axios from 'axios';
import { API_BASE_URL } from '../../../config';

export class WellsFargoSettingsApi {
  static getSettings = (organizationId) => {
    return axios.get(
      `${API_BASE_URL}/organizations/${organizationId}/wells-fargo-settings`,
    );
  };

  static updateSettings = (organizationId, data) => {
    return axios.put(
      `${API_BASE_URL}/organizations/${organizationId}/wells-fargo-settings`,
      data,
    );
  };
}
